'use client';

import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.events';
import { Icon, Text } from '@stone-payments/jade';
import { useIntl } from 'react-intl';
import { DetailText, TriggerContainer } from './style';

type SummaryTriggerProps = {
  value: string;
  trigger: () => void;
  isContentVisible: boolean;
  screen: string;
};

export function SummaryTrigger({
  value,
  trigger,
  isContentVisible,
  screen,
}: SummaryTriggerProps) {
  const { formatMessage } = useIntl();
  return (
    <TriggerContainer
      onClick={() => {
        analiticaInstance.events.homePage.detailsClicked(screen);
        trigger();
      }}
    >
      <Text variant="heading-small" color="high">
        {value}
      </Text>
      <DetailText>
        <Text color="medium">{formatMessage({ id: 'info.detail.label' })}</Text>
        <Icon
          use={isContentVisible ? 'chevron-up' : 'chevron-down'}
          size="medium"
        />
      </DetailText>
    </TriggerContainer>
  );
}
